import { useTranslation } from 'react-i18next';
import { IBatteryHalf, IClock, IHumidity, ITemperature } from 'ui/component/Icons.tsx';
import { Tag } from 'ui/component/Tag.tsx';
import { Alerts } from '#admin/component/Alerts.tsx';

export const AlertList = () => {
  const { t } = useTranslation();

  return (
    <main className="view-container">
      <section className="mb-4 flex flex-row place-content-between items-center">
        <h4>{t('navigation.alerts')}</h4>
        <div className="flex items-center justify-center gap-4">
          <span>{t('alerts.types.title')}</span>
          <Tag className="red !border-0 !p-2 flex flex-row items-center justify-center gap-2">
            <ITemperature /> {t('alerts.types.temperature')}
          </Tag>
          <Tag className="red !border-0 !p-2 flex flex-row items-center justify-center gap-2">
            <IHumidity /> {t('alerts.types.humidity')}
          </Tag>
          <Tag className="red !border-0 !p-2 flex flex-row items-center justify-center gap-2">
            <IBatteryHalf /> {t('alerts.types.battery')}
          </Tag>
          <Tag className="red !border-0 !p-2 flex flex-row items-center justify-center gap-2">
            <IClock /> {t('alerts.types.delay')}
          </Tag>
        </div>
      </section>
      <Alerts />
    </main>
  );
};
